import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { LinkButton } from "~/common/components/Link";
import { useTranslation } from "react-i18next";

interface Props {
  onClick: () => void;
  isOpen: boolean;

  hasComment: boolean;
}
export const CommentButton = ({ onClick, isOpen, hasComment }: Props) => {
  const { t } = useTranslation();

  let label;
  if (isOpen) {
    label = t("page.wishlist.comment.hide");
  } else if (hasComment) {
    label = t("page.wishlist.comment.show");
  } else {
    label = t("page.wishlist.comment.add");
  }

  const iconType = hasComment ? IconType.Comment : IconType.CommentPlus;

  return (
    <LinkButton data-test-id={"btn-open-comment"} iconBefore={<Icon type={iconType} />} onClick={onClick}>
      {label}
    </LinkButton>
  );
};
